import React, { useState, useEffect } from 'react';
import { Stack, Card, Row, Col, RowProps } from 'react-bootstrap';
import { combineClassNames } from '@odmonorepo/odfunctions';

type ToggleCardGroupProps = Omit<RowProps, 'onChange'> & {
  showRadioBtn?: boolean;
  name?: string;
  // Accept either the new typed value callback or the legacy loose signature
  onChange?: ((value: any) => void) | ((...args: any[]) => void);
  flexDirection?: 'row' | 'column';
  cardClassName?: string;
  radioContainerClassName?: string;
  radioInputClassName?: string;
  disabledIndex?: number[];
  selectedIdx?: number;
  hideIdx?: number;
  value: any;
};

export const ToggleCardGroup = ({
  showRadioBtn = false,
  name,
  onChange = () => {},
  flexDirection = 'row',
  cardClassName,
  radioContainerClassName = 'col-1 align-self-start pt-5 ms-1',
  radioInputClassName = 'me-5',
  disabledIndex,
  selectedIdx,
  hideIdx,
  value,
  ...props
}: ToggleCardGroupProps) => {
  const [selected, setSelected] = useState<number | undefined>(selectedIdx);
  useEffect(() => {
    setSelected(selectedIdx);
  }, [selectedIdx]);
  return (
    <Row
      className={combineClassNames(
        `d-flex flex-${flexDirection}`,
        props.className,
      )}
    >
      {React.Children.map(props.children, (child, i) => {
        const disabled = disabledIndex?.includes(i);
        return (
          hideIdx !== i && (
            <Col>
              <Card
                bg={
                  selected === i && !disabledIndex?.includes(i)
                    ? 'light-gray'
                    : disabledIndex?.includes(i)
                      ? 'disabled'
                      : 'white'
                }
                className={
                  'shadow-none ' +
                  combineClassNames(
                    selected === i ? 'border border-primary' : 'border',
                    cardClassName,
                  )
                }
                role="button"
                onClick={() => {
                  if (!disabled) {
                    onChange(value[i]);
                    setSelected(i);
                  }
                }}
              >
                <Stack direction="horizontal" className="p-3 fw-600 lh-base">
                  {showRadioBtn && (
                    <Col className={radioContainerClassName}>
                      <input
                        className={radioInputClassName}
                        readOnly
                        type="radio"
                        name={name}
                        checked={selected === i}
                      />
                    </Col>
                  )}
                  {child}
                </Stack>
              </Card>
            </Col>
          )
        );
      })}
    </Row>
  );
};

export default ToggleCardGroup;
